import React, {useContext, useState} from "react";
import {Elink, PayDepsoitUrl} from "../CommonComponents/Routes"
import axios from "axios";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import {Modal} from "react-bootstrap";
export default () => { // This component is Pay-Deposit-Form.
    const [Card, setCard] = useState(null)
    const [ShowLoader, setShowLoader] = useState(false)
    const [cardBrand, setCardBrand] = useState('')
    let RecordsController = useContext(RecordsManagementContext)
    let PageView = useContext(ViewMangementContext)
    let CP_PageDetails = RecordsController.CP_PageDetails
    let InputFields = CP_PageDetails.ClientPortalHeader.PortalPayment.InputFields
    let AddedCards = CP_PageDetails.ClientPortalHeader.PortalPayment.AddedCards
    let currentYear = (new Date()).getFullYear();
    let YearLimit = currentYear + 20
    const InputField = (props) => {
        let FOR = props.For
        if (InputFields[`${FOR}`].show) { // Show according to Verbiage if any column is not
            // required in pay-deposit then it will not display.
            const options = [];
            const months = ["January","February","March","April","May","June","July","August","September","October","November","December"]
            for (let i = currentYear; i <= YearLimit; i++) {
                options.push(<option value={i}>{i}</option>);
            }

            if (FOR === 'expire_moth'){
                return (
                    <select className="form-control" placeholder="MM" value={FormData[`${FOR}`]}
                            name={FOR}
                            onChange={(e) =>  ChangeFormData(
                                e.target.value, e.target.name)}>
                        <option name="" value="" style={{display:"none"}}>MM</option>
                        {months.map((month,i) => {
                            return (
                                <option name={month} value={i+1}>{month}</option>
                            )
                        })}
                    </select>
                )
            }
            else if (FOR === 'expire_year'){
                return (
                    <select className="form-control" placeholder="MM" value={FormData[`${FOR}`]}
                            name={FOR}
                            onChange={(e) =>  ChangeFormData(
                                e.target.value, e.target.name)}>
                        <option name="" value="" style={{display:"none"}}>YYYY</option>
                        {options}
                    </select>
                )
            }
            else{
                return (
                    <input className="form-control" value={FormData[`${FOR}`]}
                           onChange={(e) =>  ChangeFormData(e.target.name === "card_number"
                           || e.target.name === "cvv" ? e.target.value.replace(/\D/g, "") :
                           e.target.name === "zip_code" ? e.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase() : e.target.value, e.target.name)}
                           name={FOR} placeholder={props.PlaceHolder}/>
                )
            }

        } else {
            return (<></>)
        }
    }

    const handleChange = (card) => {
        setCard(card.id)
    }
    const [FormData, setFormData] = useState({
        card_holder_name: CP_PageDetails.ClientPortalHeader.PortalPayment.ClientName,
        email: CP_PageDetails.ClientPortalHeader.PortalPayment.ClientEmail,
        card_number: "",
        expire_moth: "",
        expire_year: "",
        cvv: null,
        billing_address: null,
        zip_code: null,
        country: null,
        city: null,
        state: null,
        brand: ""
    });

    React.useEffect(() => {
        const FirstDigit = FormData.card_number && FormData.card_number.length > 0 ? FormData.card_number[0] : undefined;
        if (FirstDigit === "3") {
            setCardBrand("amex");
        } else if (FirstDigit === "4") {
            setCardBrand("visa");
        } else if (FirstDigit === "5") {
            setCardBrand("master");
        } else if (FirstDigit === "6") {
            setCardBrand("discover");
        } else {
            setCardBrand("master");
        }
    }, [FormData.card_number]);

    const ChangeFormData = (Value, Name) => { //Handle changes if there is any change in any Input Field.
        setFormData({
            ...FormData,
            [Name]: Value,
        });
    };

    const ValidateCreditCardForm = () => { // Check validations
        let HolderName = FormData.card_holder_name,
            Number = FormData.card_number,
            ExpireMonth = FormData.expire_moth,
            ExpireYear = FormData.expire_year,
            CVV = FormData.cvv,
            BillingAddress = FormData.billing_address,
            ZipCode = FormData.zip_code

        let FirstDigit = Number[0]

        if (HolderName === "" || HolderName === null) {
            PageView.setAlertProperty({
                Message: 'Invalid Card Holder Name, Please check the card holder name',
                Type: 'warning',
                Show: true,
                AutoHide: true

            })
            return false;
        }
        if (HolderName.trim().split(' ').length < 2){
            PageView.setAlertProperty({
                Message: " Card Holder Name format should be like 'Firstname Lastname' ",
                Type: 'warning',
                Show: true,
                AutoHide: true

            })
            return false;
        }
        if ((FirstDigit === "3" || FirstDigit === "4" || FirstDigit === "5" || FirstDigit === "6" ) === false )  {
            PageView.setAlertProperty({
                Message: "Only American Express, Discover, Master Card or Visa are accepted. Please check your credit card.",
                Type: 'warning',
                Show: true,
                AutoHide: true

            })
            return false;
        }
        if (Number === "" || Number === null  || (Number.length > 16 || Number.length < 15) ){
            PageView.setAlertProperty({
                Message: 'Invalid Card Number, Please check the card number',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if (ExpireMonth === "" || ExpireMonth === null) {
            PageView.setAlertProperty({
                Message: 'Please select Expiry Month',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if (ExpireYear === "" || ExpireYear === null) {
            PageView.setAlertProperty({
                Message: 'Select Select Expiry Year',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if ((CVV === "" || CVV === null  || CVV.length > 4 ) && InputFields.cvv.show) {
            PageView.setAlertProperty({
                Message: 'Invalid Card CVV, Please check the card cvv',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if ((BillingAddress === null || BillingAddress.trim() === "" ) && InputFields.billing_address.show) {
            PageView.setAlertProperty({
                Message: 'Please Enter Billing Address',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if ((ZipCode === "" || ZipCode === null ) && InputFields.zip_code.show) {
            PageView.setAlertProperty({
                Message: 'Please Enter Zip Code',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if ((FormData.country === null || FormData.country.trim() === "" ) && InputFields.country.show) {
            PageView.setAlertProperty({
                Message: 'Please Enter Billing Country',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if ((FormData.state === null || FormData.state.trim() === "" ) && InputFields.state.show) {
            PageView.setAlertProperty({
                Message: 'Please Enter Billing State/Province',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if ((FormData.city === null || FormData.city.trim() === "" ) && InputFields.city.show) {
            PageView.setAlertProperty({
                Message: 'Please Enter Billing City',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }
        if ((FormData.email === null || FormData.email.trim() === "" ) && InputFields.email.show) {
            PageView.setAlertProperty({
                Message: 'Please Enter Billing Email',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            return false;
        }

        return true
    }

    const payDeposit = async () => {
        let Data = {
            estimate_key: Elink,
            credit_card_payment: {
                credit_card_id: '',
                estimate_id: '',
                cc_fee: CP_PageDetails.ClientPortalHeader.PortalPayment.CcProcessingFee,
                charged_amount: CP_PageDetails.ClientPortalHeader.PortalPayment.TotalDepositAmount
            },
            credit_card: {
                credit_card_status: "activated",
                card_holder: FormData.card_holder_name,
                number: FormData.card_number,
                expire_month: FormData.expire_moth,
                expire_year: FormData.expire_year,
                card_verification_value: FormData.cvv,
                address: FormData.billing_address,
                zip_code: FormData.zip_code,
                country: FormData.country,
                state: FormData.state,
                city: FormData.city,
                email: FormData.email
            }
        }
        if (ValidateCreditCardForm()) {
            Data.credit_card.brand = cardBrand;
            setShowLoader(true) //show loader while request is being processed.
            await axios({method: 'post', url: PayDepsoitUrl, data: Data})
                .then((response) => {
                    if (response.data[1] === true){
                        RecordsController.SetCP_PageDetails({
                            ...RecordsController.CP_PageDetails,
                            EstimateAndCompanyInfo: {
                                ...RecordsController.CP_PageDetails.EstimateAndCompanyInfo,
                                IsPortalPaymentDeposit: response.data[1]
                            },
                            ClientPortalHeader: {
                                ...RecordsController.CP_PageDetails.ClientPortalHeader,
                                PortalPayment: response.data[0]
                            }
                        })
                        setShowLoader(false) //hide loader
                        RecordsController.setPaymentModal(false)//close the modal
                        PageView.setModalContent({Title: '', Body: '', Class: ''})
                        PageView.setAlertProperty({
                            Message: 'Payment has been Done..!',
                            Type: 'info',
                            Show: true,
                            AutoHide: true
                        })
                    }else {
                        PageView.setAlertProperty({
                            Message: response.data[2],
                            Type: 'warning',
                            Show: true,
                            AutoHide: true
                        })
                        setShowLoader(false)
                    }
                }).catch(() => {
                    PageView.setAlertProperty({
                        Message: 'Payment is declined........ Please try again',
                        Type: 'warning',
                        Show: true,
                        AutoHide: true
                    })
                    setShowLoader(false)
                })
        }
    }
    const DepositForm = async () => {
        let cookie = document.cookie.split('employee_id=')[1]
        let Data = {
            estimate_key: Elink,
            employee_key: cookie,
            credit_card_payment: {
                credit_card_id: Card,
                estimate_id: '',
                cc_fee: CP_PageDetails.ClientPortalHeader.PortalPayment.CcProcessingFee,
                charged_amount: CP_PageDetails.ClientPortalHeader.PortalPayment.TotalDepositAmount
            }
        }
        if ( Card !== null ) {//if card is selected
            await setShowLoader(true) //show loader while request is being processed.
            await axios({method: 'post', url: PayDepsoitUrl, data: Data})
                .then(async (response) => {
                    if (response.data[1] === true){
                        await setShowLoader(false)
                        RecordsController.setPaymentModal(false)
                        await PageView.setModalContent({Title: '', Body: '', Class: ''})
                        await PageView.setAlertProperty({
                            Message: 'Payment has been Done..!',
                            Type: 'info',
                            Show: true,
                            AutoHide: true
                        })
                        await RecordsController.SetCP_PageDetails({
                            ...RecordsController.CP_PageDetails,
                            EstimateAndCompanyInfo: {
                                ...RecordsController.CP_PageDetails.EstimateAndCompanyInfo,
                                IsPortalPaymentDeposit: response.data[1]
                            },
                            ClientPortalHeader: {
                                ...RecordsController.CP_PageDetails.ClientPortalHeader,
                                PortalPayment: response.data[0]
                            }
                        })
                    }else {
                        PageView.setAlertProperty({
                            Message: response.data[2],
                            Type: 'warning',
                            Show: true,
                            AutoHide: true
                        })
                        setShowLoader(false)
                    }
                }).catch(() => {
                    PageView.setAlertProperty({
                        Message: 'Payment is declined........ Please try again',
                        Type: 'warning',
                        Show: true,
                        AutoHide: true
                    })
                    setShowLoader(false)
                })
            setCard(null)
        }
        else{
            PageView.setAlertProperty({Message: 'Please select the card to proceed the payment', Type: 'warning', Show: true, AutoHide: true})
        }
    }


    const DepositBtn = (props) => { //if we add new card  then hit goes to "payDeposit" otherwise goes to "DepositForm" component
        return(
            props.NewCard === true ?
                <div className=' text-center'  style={{paddingTop: "1%"}}>
                    <div className="btn btn-primary " id ="myModal" onClick={() => payDeposit()}>
                        <b style={{paddingLeft: "8px"}}> Pay Deposit</b></div> </div> :
                <div className="btn btn-primary "
                     onClick={() => DepositForm()}><b style={{paddingLeft: "8px",paddingTop: "1%"}}> Pay Deposit</b></div>
        )
    }

    return (
        <>
            {ShowLoader ?
                <div style={{ zIndex: 9999, position: "absolute", textAlign:"center", top:'170px', right:0, left:0}}>
                    <img src={process.env.PUBLIC_URL + "/Images/Loader21.gif"} alt="Please Wait........"/></div> :
                <></>
            }
            <div style={ShowLoader ? {
                pointerEvents: "none", opacity: "0.3",zIndex:800
            } : {}}>
                <div className='deposit-amount-wp'><b>Deposit
                    amount:<span> {CP_PageDetails.Currency}{CP_PageDetails.ClientPortalHeader.PortalPayment.Amount}</span></b>
                    {CP_PageDetails.ClientPortalHeader.PortalPayment.CcFeeEnable &&(
                    <>
                    <div className='cc-processing'>+{CP_PageDetails.ClientPortalHeader.PortalPayment.CcVerbiage}:
                        <span> {CP_PageDetails.Currency}{CP_PageDetails.ClientPortalHeader.PortalPayment.CcProcessingFee}</span>
                        </div>
                        <div className='total-deposit'>Total:
                        <b> <span> {CP_PageDetails.Currency}{CP_PageDetails.ClientPortalHeader.PortalPayment.TotalDepositAmount}</span></b>
                        </div>
                    </>
                    )}
                </div>
                <div className='paydeposit-wp'>
                    <form className="form-horizontal">
                        <Tabs defaultActiveKey="first">
                            <Tab eventKey="first" title="New Card"><br/>
                                <label>CREDIT CARD DETAILS :</label>
                                {InputField({For: 'card_holder_name', PlaceHolder: "Card Holder Name"})}
                                {InputField({For: 'card_number', PlaceHolder: 'Card Number'})}
                                <input type="hidden" name="credit_card_brand" value={cardBrand}/>

                                <div className="row col-padding-remove">
                                    <div className="col">
                                        {InputField({For: 'expire_moth', PlaceHolder: 'MM'})}
                                    </div>
                                    <div className="col">
                                        {InputField({For: 'expire_year', PlaceHolder: 'YYYY'})}
                                    </div>
                                    <div className="col">
                                        {InputField({For: 'cvv', PlaceHolder: 'CVV'})}
                                    </div>
                                </div>
                                {InputField({For: 'billing_address', PlaceHolder: 'Billing Address'})}
                                <div className="row">
                                    <div className="col-6">
                                        {InputField({For: 'zip_code', PlaceHolder: 'Zip Code'})}
                                    </div>
                                    <div className="col-6">
                                        {InputField({For: 'country', PlaceHolder: 'Country'})}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        {InputField({For: 'state', PlaceHolder: 'State/Province'})}
                                    </div>
                                    <div className="col-6">
                                        {InputField({For: 'city', PlaceHolder: 'City'})}
                                    </div>
                                </div>
                                {InputField({For: 'email', PlaceHolder: 'Email'})}
                                <DepositBtn NewCard={true}/>
                            </Tab>

                            <Tab eventKey="second" title="Added Card">
                                {AddedCards.length > 0 ?
                                    <>
                                        {AddedCards.map((card, key) => {
                                            return (
                                                <div className="radio d-flex" style={{marginTop:"2%"}} key={key + "radio_btns"}>
                                                    <div>
                                                        <input type="radio" key={key + "cards"} id={card.id} name="cards"
                                                               value={card.card_number}
                                                               onChange={() => handleChange(card)}/></div> &nbsp;&nbsp;&nbsp;
                                                    <div>
                                                        <label key={key + "card_num"} htmlFor={card.id} style={{paddingTop:"16%"}}>
                                                            <b> {card.card_number + " " + card.card_brand} </b></label>
                                                    </div>
                                                    <br/>
                                                </div>
                                            )
                                        })}
                                        <div className="d-flex justify-content-center">
                                            <DepositBtn NewCard={false}/>
                                        </div>
                                         </> : <div className={'text-center'}
                                                                                       style={{paddingTop: "30%"}}>No Card
                                        Added </div>}
                            </Tab>
                        </Tabs>
                    </form>
                </div>
            </div>
        </>
    )
}
